import sideBarDefaultLogo from "@assets/images/sidebar-default-logo.png";
import sideBarDefaultLogoDarkMode from "@assets/images/sidebar-default-logo-darkMode.png";
import { useLegacyThemeHandler } from "@dashboard/components/Sidebar/user/Controls";
import { Avatar, Box, Text } from "@saleor/macaw-ui-next";
import React from "react";

export const MountingPoint = () => {
  const { theme } = useLegacyThemeHandler();
  const logo =
    theme === "defaultLight" ? sideBarDefaultLogo : sideBarDefaultLogoDarkMode;

  return (
    <Box display="flex" gap={3} paddingX={4} paddingY={5} alignItems="center">
      <Avatar.Store src={logo} scheme="accent1" size="small" />
      <Text variant="bodyStrong" size="small">
        Saleor Dashboard
      </Text>
    </Box>
  );
};
